import '_premierworld/scss/entries/home.scss';
/** Import the dependencies of the page */
import config from '_config';
import jQuery from 'jquery';
import DocumentObj from '_loaders/Document';
import '_loaders/OverlayScrollbars';
import '_loaders/Form';
import '_loaders/IntlTelInput';
import Init from '_loaders/Initer';
import ModalDialog from '_loaders/ModalDialog';
import 'bootstrap';
import '_loaders/NotificationBox';

jQuery(document).ready(function () {
    /** run all the functions that should be run at the beginning of document ready for ALL files in use */
    DocumentObj.readyStart();

    /** run functions that should be run at the end of document ready for all pages */
    DocumentObj.readyEnd();

    jQuery('.menu-toggle-button').on('click', function() {
        jQuery('nav').toggleClass('mobile-menu-opened');
        jQuery('.menu-elems-list').toggleClass('active');
    });

    jQuery('.language-selector-menu-elem').on('click', function() {
        window.location.replace(config.siteUrl + jQuery(this).data('language-code') + '/home');
    });

    jQuery('.menu-button.language-select').on('click', function() {
        jQuery('.languages-wrapper').addClass('active');
    });

    jQuery('.read-more-offer').on('click', function() {
        window.location.replace(config.siteUrl + jQuery('body').data('language') + '/offers/' + jQuery(this).data('link') + '/');
    });
});

jQuery(document).on('click', '.portfolio-link', function() {
    let options = jQuery(this).data('dialog');

    options.highlightImageUrl = options.images[0];
    options.onshown = function(dialog) {
        jQuery(dialog.dom.main.find('.thumbnail-holder img').get(0)).addClass('selected');
        Init.all();
        dialog.dom.main.find('.thumbnail-holder img').on('click', function() {
            dialog.dom.main.find('.thumbnail-holder img').removeClass('selected');
            jQuery(this).addClass('selected');
            dialog.dom.main.find('.highlight-image img').attr('src', jQuery(this).attr('src'));
        });
    }

    console.log(options);
    new ModalDialog(options);
});

function scrollToSection(elem) {
    jQuery('section').each(function() {
        if (jQuery(elem).data('section') == jQuery(this).data('section')) {
            jQuery("body").data('os-scroll').scroll({y:jQuery(this).position().top + 'px'}, 300);
        }
    });

    jQuery('.menu-elems-list').removeClass('active');
    jQuery('nav').removeClass('mobile-menu-opened');
}

function expandOurBusiness(elem) {
    let textColumn = jQuery(elem).parent('.text-column'),
        data = {
            'title' :   textColumn.data('expanded-title'),
            'text'  :   textColumn.data('expanded-text')
        };

    let overlay = jQuery('<div></div>').addClass('text-column-expanded-overlay'),
        expandedTitle = jQuery('<h3></h3>').addClass('text-colum-expanded-title').html(data.title),
        expandedText = jQuery('<div></div>').addClass('text-column-expanded-text').html(data.text),
        backButton = jQuery('<button onclick="closeExpandedOurBusiness(this)"></button>').addClass('text-column-expanded-button pw-button').html('Back');

    overlay.append(expandedTitle).append(expandedText).append(backButton);

    jQuery('.text-columns-container').append(overlay);

    if ((window.innerWidth <= 768)) {
        jQuery("body").data('os-scroll').scroll({y:jQuery('.text-columns-container').position().top + 'px'}, 300);
    }
}

function closeExpandedOurBusiness(elem) {
    jQuery(elem).parent('.text-column-expanded-overlay').remove();
}

window.scrollToSection = scrollToSection;
window.expandOurBusiness = expandOurBusiness;
window.closeExpandedOurBusiness = closeExpandedOurBusiness;
/** Migrate some functionalities to the outer window scope */